import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

//import context
import { MyContext } from "../../../../tenantsDashContext";

//tour utilities
import {
  tourSteps,
  getCurrentTourStep,
  isInTourMode,
  shouldShowNavItem,
} from "../../../../utils/tourUtils";

//import icons

import { RiMessage2Line } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import { FaUsers } from "react-icons/fa";
import { MdPayment } from "react-icons/md";
import { LiaFileInvoiceSolid } from "react-icons/lia";

//import css
import "./Mobile-Nav.scss";

const ROUTE_SEGMENT_MAP = {
  Overview: "overview",
  Properties: "properties",
  Tenants: "tenants",
  Invoices: "invoices",
  Payments: "payments",
  Expenses: "expenses",
  Reports: "reports",
  Messages: "messages",
  Profile: "profile",
};

const MobileNav = () => {
  const { sharedValue, setSharedValue } = useContext(MyContext);
  const navigate = useNavigate();
  const [activeNavItem, setActiveNavItem] = useState("Overview"); // Set the default active item
  const [isFirstTime, setIsFirstTime] = useState(false);
  const [tourStep, setTourStep] = useState(0);

  useEffect(() => {
    if (sharedValue) {
      setActiveNavItem(sharedValue);
    }
  }, [sharedValue]);

  useEffect(() => {
    const firstTimeFlag = isInTourMode();
    const savedTourStep = getCurrentTourStep();

    if (firstTimeFlag) {
      setIsFirstTime(true);
      setTourStep(savedTourStep);
      // Set active item to the current tour step
      setActiveNavItem(tourSteps[savedTourStep] || "Profile");
    }
  }, []);

  const handleNavClick = (item) => {
    // During tour mode, don't allow navigation to locked steps
    if (isFirstTime) {
      const itemStepIndex = tourSteps.indexOf(item);
      const currentStepIndex = tourStep;

      // Allow navigation to current step or previously unlocked steps
      if (itemStepIndex > currentStepIndex) {
        // Don't allow navigation to locked steps
        return;
      }
    }

    setActiveNavItem(item);
    setSharedValue(item);

    const routeSegment = ROUTE_SEGMENT_MAP[item];
    if (routeSegment) {
      navigate(`/auth/landlord/${routeSegment}`);
    }

    console.log("Shared Value:", sharedValue);
  };

  return (
    <nav className="mobile-nav">
      <button
        onClick={() => handleNavClick("Overview")}
        style={{
          display: shouldShowNavItem("Overview") ? "block" : "none",
        }}
      >
        <div
          className={`nav-item ${
            activeNavItem === "Overview" ? "nav-item-active" : ""
          }`}
        >
          <RxDashboard size={24} />
          <span className="nav-text">Overview</span>
        </div>
      </button>
      <button
        onClick={() => handleNavClick("Tenants")}
        style={{
          display: shouldShowNavItem("Tenants") ? "block" : "none",
        }}
      >
        <div
          className={`nav-item ${
            activeNavItem === "Tenants" ? "nav-item-active" : ""
          }`}
        >
          <FaUsers size={24} />
          <span className="nav-text">Tenants</span>
        </div>
      </button>
      <button
        onClick={() => handleNavClick("Payments")}
        style={{
          display: shouldShowNavItem("Payments") ? "block" : "none",
        }}
      >
        <div
          className={`nav-item ${
            activeNavItem === "Payments" ? "nav-item-active" : ""
          }`}
        >
          <MdPayment size={24} />
          <span className="nav-text">Payments</span>
        </div>
      </button>
      <button
        onClick={() => handleNavClick("Invoices")}
        style={{
          display: shouldShowNavItem("Invoices") ? "block" : "none",
        }}
      >
        <div
          className={`nav-item ${
            activeNavItem === "Invoices" ? "nav-item-active" : ""
          }`}
        >
          <LiaFileInvoiceSolid size={24} />
          <span className="nav-text">Invoices</span>
        </div>
      </button>
      <button onClick={() => handleNavClick("Messages")}>
        <div
          className={`nav-item ${
            activeNavItem === "Messages" ? "nav-item-active" : ""
          }`}
        >
          <RiMessage2Line size={24} />
          <span className="nav-text">Messages</span>
        </div>
      </button>
    </nav>
  );
};

export default MobileNav;
